// extracted by mini-css-extract-plugin
module.exports = {"taulaDesplegableFiltre":"TaulaOrdenacioCerca_taulaDesplegableFiltre__2i5zY","taulaDesplegableFiltreTextDestacat":"TaulaOrdenacioCerca_taulaDesplegableFiltreTextDestacat__72C70"};